import PDFKit, { link, list } from 'pdfkit';
import { saveAs } from './FileSaver.min.js';
import { getAllGuidebookInfo } from './epubGeneration.js';
import BlobStream from 'blob-stream';
import * as cheerio from 'cheerio';
import html2pdf from 'html-to-pdf-js';
import { decodeHtml } from '../components/guidebooks/FeaturedGuidebooks.js';

let sizes = {
  bodyFont: 10,
  titleFont: 24,
  h2Font: 18,
  h3Font: 14,
  h4Font: 12,
  hMarginLarge: 0.9,
  hMargin: 0.2,
  pMargin: 0.8,
  sectionMargin: 2,
};

// let newGeneratePDF = (guidebookContent) => {
//   let options = {
//     title: guidebookContent.title,
//     filename: `${guidebookContent.title}.pdf`,
//     margins: [100, 50, 100, 50],
//     pagebreak: { mode: 'avoid-all' },
//     enableLinks: true,
//   };

//   let html = '';
//   // Put the title in as an h1
//   html += `<h1>${guidebookContent.title}</h1>`;
//   // Construct the html string from the guidebookContent sections
//   guidebookContent.sections.forEach((section) => {
//     html += `<h2>${section.title}</h2>`;
//     html += section.content;
//   });

//   html2pdf().set(options).from(html).save();
// };

let generatePDF = (guidebookContent) => {
  let doc = new PDFKit();
  let stream = doc.pipe(BlobStream());
  doc.fontSize(sizes.titleFont);

  doc.font('Helvetica-Bold');
  doc.text(decodeHtml(guidebookContent.title)).moveDown(1);
  doc.font('Helvetica');
  // Iterate through the sections and add them to the PDF.
  guidebookContent.sections.forEach((section) => {
    // strip all html content and html characters
    section.title = section.title.replace(/<[^>]*>?/gm, '');
    // section.content = section.content.replace(/<[^>]*>?/gm, '');
    // remove html entities
    section.title = section.title.replace(/&nbsp;/g, ' ');
    section.title = decodeHtml(section.title);
    section.content = section.content.replace(/&nbsp;/g, ' ');
    section.content = decodeHtml(section.content);

    doc.fontSize(sizes.titleFont);
    doc.text(section.title).moveDown(sizes.hMargin);
    doc.fontSize(sizes.bodyFont);
    // Parse html into doc
    doc = parseHtmlIntoDoc(doc, section.content);
    doc.moveDown(sizes.sectionMargin);
  });
  doc.end();
  stream.on('finish', function () {
    // get a blob you can do whatever you like with
    const blob = stream.toBlob('application/pdf');
    saveAs(blob, `${decodeHtml(guidebookContent.title)}.pdf`);
  });
};

let downloadGuidebookPdf = async (guidebookSlug) => {
  let guidebookContent = await getAllGuidebookInfo(guidebookSlug);
  generatePDF(guidebookContent);
  // newGeneratePDF(guidebookContent);
};

let parseHtmlIntoDoc = (doc, html) => {
  // Iterate through the html elements found within the html, and add them to the doc based on their tags.
  let $ = cheerio.load(html);
  $('body')
    .children()
    .each((i, element) => {
      let tagName = element.tagName;
      if (tagName === 'h1') {
        doc.fontSize(sizes.titleFont);
        doc.text($(element).text()).moveDown(sizes.hMarginLarge);
      } else if (tagName === 'h2') {
        doc.fontSize(sizes.h2Font);
        doc.text($(element).text()).moveDown(sizes.hMargin);
      } else if (tagName === 'h3') {
        doc.fontSize(sizes.h3Font);
        doc.text($(element).text()).moveDown(sizes.hMargin);
      } else if (tagName === 'p') {
        doc.fontSize(sizes.bodyFont);
        //Replace br tags with newlines
        $(element).find('br').replaceWith('\n');
        // Handle inline links
        // First we need to check if there are any links in the paragraph.

        let links = $(element).find('a');
        if (links.length > 0) {
          // If there are links, we need to iterate through the links and add them to the doc
          // we need to create an array of text, links and their start, end locations within the string.
          let text = $(element).text();
          let linkArray = [];
          let linkStart = 0;
          let linkEnd = 0;
          let linkText = '';
          let linkHref = '';
          let linkObj = {};
          links.each((i, link) => {
            linkStart = text.indexOf($(link).text());
            linkEnd = linkStart + $(link).text().length;
            linkText = $(link).text();
            linkHref = $(link).attr('href');
            linkObj = {
              linkStart,
              linkEnd,
              linkText,
              linkHref,
            };
            linkArray.push(linkObj);
          });

          // Now we need to iterate through the linkArray and add the text and links to the doc.
          let currentTextPosition = 0;
          linkArray.forEach((link) => {
            // print the regular text before the link
            doc.text(text.slice(currentTextPosition, link.linkStart), {
              link: null,
              underline: false,
              continued: true,
            });
            // print the link
            doc.text(link.linkText, {
              link: link.linkHref,
              underline: true,
              continued: true,
            });

            // set the link position tot he end of the link
            currentTextPosition = link.linkEnd;

            // set the text to the remaining text
          });
          // Finally, we need to add the remaining text to the doc.
          doc
            .text(text.slice(currentTextPosition, text.length), {
              continued: false,
              underline: false,
              link: null,
            })
            .moveDown(sizes.pMargin);
        } else {
          doc.fontSize(sizes.bodyFont);
          doc.text($(element).text()).moveDown(sizes.pMargin);
        }
      } else if (tagName === 'ul') {
        doc = handleListGeneration($, doc, element);
      } else if (tagName === 'ol') {
        doc = handleListGeneration($, doc, element);
      } else if (tagName === 'br') {
        doc.moveDown(sizes.pMargin);
      } else {
        // strip all html content and html characters
        let text = $(element).text();
        // convert html entities to regular characters
        text = text.replace(/&nbsp;/g, ' ');
        doc.fontSize(sizes.bodyFont);
        doc.text(text).moveDown(sizes.pMargin);
      }
    });

  return doc;
};

let handleListGeneration = ($, doc, element) => {
  doc.fontSize(sizes.bodyFont);
  // Create a multi-dimensional array of the list items based on the element's children.
  let listItems = [];
  $(element)
    .children()
    .each((i, li) => {
      listItems.push($(li).text());
    });
  // Iterate through the list items and add them to the doc.

  // remove everything that isn't a regular space from the list items
  listItems = listItems.map((item) => {
    // and the return character
    return item.replace(/&nbsp;/g, ' ').replace(/\n/g, '');
  });
  doc.list(listItems, { bulletRadius: 1.5 }).moveDown(sizes.pMargin);

  return doc;
};

let downloadResourcePdf = async (resource) => {
  // Construct the info html for the resource.
  let infoHtml = `<h1>${decodeHtml(resource.title.rendered)}</h1>`;
  infoHtml += `<p><strong>Authors:</strong> ${resource.acf.resource_authors}</p>`;
  infoHtml += `<p><strong>Publication Date:</strong> ${
    new Date(resource.date).toLocaleString().split(',')[0]
  }</p>`;
  infoHtml += `<p><strong>Categories:</strong> `;
  resource._embedded['wp:term'][0].forEach((category) => {
    infoHtml += `${category.name}, `;
  });
  // remove the final comma and space
  infoHtml = infoHtml.slice(0, -2);
  infoHtml += `</p>`;

  // Construct the full html including the post content
  let html = infoHtml + resource.content.rendered;
  // Create our similar object to the guidebookContent object
  let resourceContent = {
    title: resource.title.rendered,
    sections: [
      {
        title: '',
        content: html,
      },
      {
        title: resource.title.rendered,
        content: resource.content.rendered,
      },
    ],
  };
  // Create the pdf
  generatePDF(resourceContent);
};

export { downloadGuidebookPdf, downloadResourcePdf };
